$(document).ready(function () {

  //faq
  $(document).on('click', 'a.faqSummary__Link', function (e) {
    e.preventDefault();
    $('.faqSummary__Item').removeClass('is-active');
    $(this).closest('.faqSummary__Item').toggleClass('is-active');
    let id = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(id).offset().top - 115
    }, 1000);
		$('.faq_wrapper').removeClass( 'is-active');
		const target = $(this).attr( 'href');
		$(target).addClass( 'is-active')

  });



});
